import { lazy } from 'react';

export const ErrorPage = lazy(() => import('./ui/ErrorPage'));

export const InternalServerErrorAsync = lazy(
  () => import('./ui/InternalServerError'),
);
